import React, { useEffect, useState } from 'react';
import { HomePage } from './pages/HomePage';
import { MyStoryPage } from './pages/MyStoryPage';
import { ServicesPage } from './pages/ServicesPage';
import { ResultsPage } from './pages/ResultsPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { ContactPage } from './pages/ContactPage';
import { BookedPage } from './pages/BookedPage';

// Support a plain /booked URL (e.g. a scheduler redirect) by mapping it
// onto the site's hash routing.
function getInitialPath() {
  if (window.location.pathname.replace(/\/+$/, '') === '/booked') {
    window.history.replaceState(null, '', '/#/booked');
  }
  return window.location.hash;
}
export function App() {
  const [currentPath, setCurrentPath] = useState(getInitialPath);
  useEffect(() => {
    const onLocationChange = () => {
      setCurrentPath(window.location.hash);
      // Scroll to top on route change
      window.scrollTo(0, 0);
    };
    window.addEventListener('hashchange', onLocationChange);
    return () => window.removeEventListener('hashchange', onLocationChange);
  }, []);
  // Simple router
  if (currentPath === '#/my-story') {
    return <MyStoryPage data-id="element-0" data-mp="3mjzpgvevclx2" />;
  }
  if (currentPath === '#/services') {
    return <ServicesPage data-id="element-1" data-mp="3rbzq6q2rjiup" />;
  }
  if (currentPath === '#/results') {
    return <ResultsPage data-id="element-2" data-mp="5yhgo69t1c8" />;
  }
  if (currentPath === '#/resources') {
    return <ResourcesPage data-id="element-3" data-mp="56lhc8rh1lf" />;
  }
  if (currentPath === '#/contact' || currentPath === '#/contact/book') {
    return <ContactPage data-id="element-4" data-mp="2zn6b4vo3kbmp" />;
  }
  if (currentPath === '#/booked') {
    return <BookedPage data-id="element-5" data-mp="33nges1of2pye" />;
  }
  // Default route
  return <HomePage data-id="element-6" data-mp="33oi152avuyvf" />;
}